export const iconFontAwesomeHumanitarianPlug = (
	<i className="fa-solid fa-plug"></i>
);
